export const getSafeRedirectUrl = (url: string) => {
    return url
        ? `http://clck.yandex.ru/redir/dtype=stred/*data=url%3D${encodeURIComponent(url)}`
        : '';
};
